import type { IntegrationsModuleConfig } from '../../types/modules/integrations';

export const DEFAULT_INTEGRATIONS_MODULE_CONFIG: IntegrationsModuleConfig = {
  enabled: false,
  debug: false,
  concurrency: 3,
  timeoutMs: 5000,
  continueOnError: true,

  destinations: {
    console: { enabled: false },
    memory: { enabled: false },
    mock: { enabled: false },
    meta: {
      enabled: false,
      pixelIds: [],
      autoPageView: true,
      loadScript: true,
    },
    google: {
      enabled: false,
      tagIds: [],
      autoPageView: true,
      loadScript: true,
    },
    tiktok: {
      enabled: false,
      pixelIds: [],
      autoPageView: true,
      loadScript: true,
    },
  },
};
